<template>
  <div class="question-item bg-white box-border px-4 pb-1">
    <!-- unknown-wrap 只有在量表生效 -->
    <div :class="{ 'unknown-wrap': question.issue.show_unknown }">
      <div ref="title" class="q-title leading-base break-words" v-html="title"></div>
    </div>
    <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
      <div ref="note" class="q-desc text-medium break-words leading-base pl-5 mt-1" :class="getNoteClass" v-if="showNote">
        <div v-html="question.note"></div>
      </div>
      <div v-if="isOverFlowNote" class="operate-btn" @click="isOpenNote = !isOpenNote">
        <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
        <van-icon :name="isOpenNote ? 'arrow-up' : 'arrow-down'"></van-icon>
      </div>
    </div>
    <div class="q-content mt-2" ref="qContent">
      <component :is="componentName" :question="question" view />
    </div>
    <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
      <adapter-upload-files :content="content" />
    </template>
    <template v-if="hasAnswerScore">
      <div class="bg-card-bg-gray py-4 px-4 mt-2 leading-18">
        <div v-if="!isCorrectAnswer">
          <span class="correct-answer correct-error text-danger">回答错误 +0分</span>
        </div>
        <div v-else>
          <span class="text-green-theme">回答正确 {{ score > 0 ?'+'+score :score }}分</span>
        </div>
        <!--        <div class="mb-2" v-if="!isCorrectAnswer">
          <div>
            <span>正确答案</span>
          </div>
          <ul>
            <li v-for="item in correctAnswerList" :key="item.id">
              <div v-html="item.content.richText"></div>
            </li>
          </ul>
        </div>-->
        <div v-if="answerScore.answerAnalysis">
          <span class="text">答案解析：</span>
          <span class="analysis" v-html="answerScore.answerAnalysis"></span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Question from '@/components/Question'

export default {
  name: 'PreviewQuestion',
  extends: Question,
  computed: {
    hasAnswerScore() {
      if (!this.question.setting.enableAnswerScore) return false
      return !!(this.answerScore.optionScoreItems || []).length
    },
    answerScore() {
      return this.question.answerScore || {}
    },
    isCorrectAnswer() {
      if (!this.question.setting.enableAnswerScore) return false
      const issue = this.question.issue
      if (issue.isCorrectAnswer) {
        return issue.isCorrectAnswer(this.answerScore)
      } else {
        return true
      }
    },
    correctAnswerList() {
      const issue = this.question.issue
      if (issue.getCorrectAnswerList) {
        return this.question.getCorrectAnswerList(this.answerScore)
      } else {
        return []
      }
    },
    totalScore() {
      const issue = this.question.issue
      if (issue.getTotalScore) {
        return issue.getTotalScore(this.answerScore)
      } else {
        return ''
      }
    },
    score() {
      if (!this.question.setting.enableAnswerScore) return ''
      const issue = this.question.issue
      if (issue.getScore) {
        return issue.getScore(this.answerScore)
      } else {
        return ''
      }
    }
  }
}
</script>
